import type { CanDeactivateFn } from '@angular/router';
import type { ProjectWizardPageComponent } from './project-wizard-page.component';

export const projectWizardLeaveGuard: CanDeactivateFn<ProjectWizardPageComponent> = component => component.canDeactivate();
